import { newMessages } from "../../../services/Aeat.jsx";
import Button from "./Button.jsx";

const NewMessagesButton = ({ refetch }) => {
  const handleNewMessages = async (e) => {
    e.preventDefault();
    try {
      await newMessages();
      await refetch();
    } catch (err) {
      console.error("Error completo:", err);
      alert(
        `No se pudo descargar el CSV:\n`
          + `${err.response?.status || ""} ${err.response?.statusText || err.message}`,
      );
    }
  };
  return <Button onClick={handleNewMessages}>Actualizar</Button>;
};

export default NewMessagesButton;
